import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Image } from 'app/modules/projects/projects.types';

@Injectable({ providedIn: 'root' })
export class ImageService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  upload(relatedToId: number, file: File, paramName = 'value_id'): Observable<Image> {
    const uploadData = new FormData();
    uploadData.append('image[attachment]', file);

    return this.httpClient
      .post<{ image: Image }>(`images?${paramName}=${relatedToId}`, uploadData)
      .pipe(map(({ image }) => image));
  }

  delete(id: number): Observable<Image> {
    return this.httpClient.delete<{ image: Image }>(`images/${id}`).pipe(map(({ image }) => image));
  }
}
